<div>
    <h2 class="mat-title">
        Eligible Courses Editor
    </h2>
    <div>
        <div *ngIf="Courses">There are currently {{Courses.length}} eligible dual enrollment courses in the DELTA system. <button mat-raised-button color="accent" (click)="DownloadEligibleCoursesPDF()">Download Eligible Courses PDF</button></div>
        <br />
        <div>Please use the buttons below to add or remove eligible courses for the DELTA system. Please note that these changes are immediate; removing an eligible course will not remove the course from any student's DELTA record, but will prevent it from being selected by any future students using the DELTA system.</div>
        <div class="buttongroup" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button mat-raised-button color="primary" (click)="ShowCourseEntryEditorPanel()">Add New Eligible Course</button>
        </div>
    </div>    

    <!-- New Course Entry Panel -->
    <div [hidden]="ShowingCourseEntryPanel !== true" class="mat-elevation-z12 entrypanel" style="margin-bottom:20px">
        <h2>New Eligible Course Entry Form</h2>
        <form [formGroup]="CourseEntryForm" novalidate fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
                <mat-form-field floatPlaceholder="never">
                    <input matInput formControlName="Prefix" placeholder="Ex: MAC" type="text" maxlength="3" style="text-transform: uppercase" />
                    <mat-hint>Prefix Code</mat-hint>
                    <mat-error>Must provide prefix code</mat-error>
                </mat-form-field>
                <mat-form-field floatPlaceholder="never">
                    <input matInput formControlName="Code" placeholder="Ex: 2301" type="text" maxlength="10" style="text-transform: uppercase" />
                    <mat-hint>Course Code</mat-hint>
                    <mat-error>Must provide course code</mat-error>
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <app-tags
                        #newTag
                        [options]="TagOptions"
                        [tagData]="[]"
                        [control]="this.CourseEntryForm.get('Colleges')"
                        [tagType]="TagTypes.College"
                        [isVertical]="false"
                        [showAddLabel]="true"
                    >
                    </app-tags>
                    <mat-error *ngIf="CourseEntryForm.invalid && (newTag.control.touched) && !newTag.control.value.length">
                        Please select at least 1 college
                    </mat-error>
                </div>
            </div>
            <div>
                <em>Note: If the course being added is a modular course, it is <strong>NOT</strong> necessary to add each module in this tool. Simply add the code without the -1, -2, or -T suffix to add all courses in the sequence as eligible.</em>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">        
                <button mat-raised-button color="primary" (click)="AddEligibleCourse(newTag.control.value)" 
                    [disabled]="CourseEntryForm.invalid || !newTag.control.value.length"
                >Add New Eligible Course</button>
                <button mat-raised-button color="warn" (click)="AddCourseCancelHandler()">Cancel</button>
            </div>
        </form>        
    </div>

    <!-- Courses Table -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="margin-top">
        <span fxAuto></span>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div>Filter:</div>
            <mat-form-field floatPlaceholder="never" class="filter">
                <input matInput type="text" [(ngModel)]="FilterText" (input)="UpdateFilter()" placeholder="Filter courses..." />
            </mat-form-field>
        </div>
    </div>
    <mat-table class="bordered" #table [dataSource]="CoursesData" matSort>
        <ng-container matColumnDef="Prefix">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Prefix</mat-header-cell>
            <mat-cell *matCellDef="let ecor" class="centered">{{ecor.Prefix}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Code">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Code</mat-header-cell>
            <mat-cell *matCellDef="let ecor" class="centered">{{ecor.Code}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Colleges">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Colleges</mat-header-cell>
            <mat-cell *matCellDef="let ecor" class="centered">
                <app-tags
                    [options]="TagOptions"
                    [tagData]="ecor.Colleges"
                    [tagType]="TagTypes.College"
                    (updateTags)="UpdateEligibleCourseColleges($event, ecor.EligibleCourseID)"
                    (addTag)="AddEligibleCourseCollege($event, ecor.EligibleCourseID)"
                    (removeTag)="RemoveEligibleCourseCollege($event, ecor.EligibleCourseID)"
                >
                </app-tags>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let ecor" class="centered">
                <button mat-raised-button color="primary" (click)="RemoveEligibleCourse(ecor)">Remove Course</button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Course(s)</mat-header-cell>
            <mat-cell *matCellDef="let ecor">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Prefix</div>
                        <div>{{ecor.Prefix}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Code</div>
                        <div>{{ecor.Code}}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center">
                        <button mat-raised-button color="primary" (click)="RemoveEligibleCourse(ecor)">Remove Course</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let ecor"><em>No eligible dual enrollment courses for the current filter are available.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <div *ngIf="!CoursesData.filtereddata.length"><em>No eligible dual enrollment courses for the current filter are available.</em></div>
    <mat-paginator #paginator [length]="CoursesData.filtereddata.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/managecourses/managecourses.component.html